import { useEffect, useState } from 'react'
import * as useragent from 'express-useragent'
import cf from '../../../common/lib/utils/common'
import { getHomePageData } from '../../../common/lib/Homepage'
import Theme12 from '../../components/pages/visa'
import visaCardStyle from '../../../common/componentsV2/visa/VisaSuccessCard/themeCss/theme12.module.css'
import visaDetailsStyle from '../../../common/componentsV2/visa/VisaDetails/themeCss/theme12.module.css'
import mobileHeaderStyle from '../../../common/componentsV2/MobileHeaderBack/themeCss/theme12.module.css'

export function VisaPage(props) {
  const theme = props?.pageInfo?.site?.site_theme

  switch (theme) {
    case 'theme12':
      return <Theme12 mobileHeaderStyle={mobileHeaderStyle} visaCardStyle={visaCardStyle} visaDetailsStyle={visaDetailsStyle} {...props}  />
    default:
      return <Theme12 mobileHeaderStyle={mobileHeaderStyle} visaCardStyle={visaCardStyle} visaDetailsStyle={visaDetailsStyle} {...props} />
  }
}

//server side rendering
export async function getServerSideProps({ req, res, params }) {
  let pageInfo = {}
  let homeData = {}
  try {
    let response = await getHomePageData(req) // home pagedata

    pageInfo = response
    const resData = response
    if (!cf.isValueEmpty(resData) && resData.status === true && !cf.isValueEmpty(resData.data)) {
      homeData = { status: true, data: resData }
    } else {
      homeData = { status: false, data: {} }
    }
  } catch (error) {
    console.log('error==========', error.message)
  }
  return {
    props: {
      pageInfo: pageInfo,
      isMobile: useragent.parse(req.headers['user-agent']).isMobile,
      home: homeData,
      userToken: req?.cookies?.userToken || '',
    },
  }
}

export default VisaPage
